import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const CustomDropdown = ({
  items = [],
  renderItem = (item) => item,
  isLoading = false,
  onSelectItem,
  maxHeight = 200,
  zIndex = 1000,
  highlightColor = "#f0f9ef",
  noResultsMessage = "No suggestions found"
}) => {
  const showDropdown = isLoading || items.length > 0;

  if (!showDropdown) return null;

  const minHeight = isLoading ? 50 : items.length === 0 ? 50 : Math.min(items.length * 44, maxHeight);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        backgroundColor: "#f5f5f5",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        borderRadius: "0 0 8px 8px",
        border: "1px solid #e0e0e0",
        zIndex,
        maxHeight: `${maxHeight}px`,
        height: minHeight,
        transition: "all 0.2s ease-in-out",
        overflowY: "auto",
        marginTop: "2px",
        display: "block",
        visibility: "visible",
      }}
    >
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : items.length > 0 ? (
        items.map((item, index) => (
          <Box
            key={index}
            onClick={() => onSelectItem(item)}
            sx={{
              padding: "10px 16px",
              cursor: "pointer",
              borderBottom: index < items.length - 1 ? "1px solid #eee" : "none",
              "&:hover": {
                backgroundColor: highlightColor,
              },
            }}
          >
            {renderItem(item)}
          </Box>
        ))
      ) : (
        <Box sx={{ padding: "10px 16px", color: "text.secondary" }}>
          <Typography variant="body2">{noResultsMessage}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomDropdown;